// services/useProject.ts

import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const BASE_URL = `${API_BASE_PATH}/project/projects`;
const TASK_API_URL = `${API_BASE_PATH}/Task/`;

export interface Project {
  id: string;
  name: string;
  logo: string;
  version: string;
  status: string;
  type: string;
  priority: string;
  priceType: string;
  value: number;
  startDate: string;
  endDate: string;
  deadline: string;
  progress: number;
  description: string;
  remarks: string;
  estimatedHours: number;
  totalHours: number;
  actualHours: number;
  clientEmail: string;
  clientUsername: string;
  clientType: string;
  projectLeadIds: string[];
  projectManagerIds: string[];
  projectMemberData?: { id: string; username: string }[];

  projectMemberIds: string[];
  tags: string[];
}

export const getProjects = async (_token: string | null,): Promise<Project[]> => {
  try {
    const response = await axios.get(BASE_URL, {
      headers: {
        accept: "application/json",
              authorization: "Bearer " + _token,
      },
    });

    // 🔧 Helper to extract and split ID strings
    const extractIds = (mapperField: string[] | undefined): string[] => {
      if (mapperField && mapperField.length > 0) {
        return mapperField[0].split(",").map((id) => id.trim());
      }
      return [];
    };
    const transformed: Project[] = response.data.map((item: any) => {
      const mapper = item.project_mapper_data?.[0] || {};

      return {
        id: item.project_id,
        name: item.project_name,
        logo: item.project_logo,
        version: item.project_version,
        status: item.status,
        type: item.project_type,
        priority: item.priority,
        priceType: item.price_type,
        value: item.project_value,
        startDate: item.start_date,
        endDate: item.end_date,
        deadline: item.deadline,
        progress: item.Project_progress,
        description: item.description,
        remarks: item.remarks,
        estimatedHours: item.estimated_hours,
        totalHours: item.total_hours,
        actualHours: item.actual_hours,
        clientEmail: item.client_data?.email || "",
        clientUsername: item.client_data?.username || "",
        clientType: item.client_data?.client_type || "",

        projectLeadIds: extractIds(mapper.project_lead),
        projectManagerIds: extractIds(mapper.project_manager),
        projectMemberIds: extractIds(mapper.project_member),

        tags: item.tags || [],
      };
    });

    return transformed;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

const BASE_URL2 = `${API_BASE_PATH}/Task/group_task_by_project_id`;

export interface Tasking {
  completed?: boolean;
  isImportant?: boolean;
  assignees?: { avatar: string }[];
  taskId: string;
  taskName: string;
  assignTo: string;
  dueDate: string;
  tags: string[];
  priority: string;
  status: string;
  view: number;
  description: string;
  uploadFile: string;
  startDate: string;
  endDate: string;
  totalHours: number;
  estimatedHours: number;
  taskStart: string | null;
  taskEnd: string | null;
  projectId: string;

  employee: {
    employeeId: string;
    username: string;
    email: string;
  };

  project: {
    projectId: string;
    projectName: string;
    projectVersion: string;
    status: string;
  };
}

export const getTasksByProjectId = async (
   _token: string | null,
  projectId: string
): Promise<Tasking[]> => {
  try {
    const response = await axios.get(`${BASE_URL2}/${projectId}`, {
      headers: {
        accept: "application/json",
               authorization: "Bearer " + _token,
      },
    });

    const transformed: Tasking[] = response.data.map((item: any) => ({
      taskId: item.task_id,
      taskName: item.task_name,
      assignTo: item.Assign_to,
      dueDate: item.due_date,
      tags: item.tags || [],
      priority: item.priority,
      status: item.status,
      view: item.view,
      description: item.descriptions,
      uploadFile: item.upload_file,
      startDate: item.start_date,
      endDate: item.end_date,
      totalHours: item.total_hours,
      estimatedHours: item.estimated_hours,
      taskStart: item.task_start,
      taskEnd: item.task_end,
      projectId: item.project_id,

      employee: {
        employeeId: item.employee?.employee_id || "",
        username: item.employee?.username || "",
        email: item.employee?.email || "",
      },
      project: {
        projectId: item.project?.project_id || "",
        projectName: item.project?.project_name || "",
        projectVersion: item.project?.project_version || "",
        status: item.project?.status || "",
      },
    }));

    return transformed;
  } catch (error: any) {
    if (
      error.response &&
      error.response.status === 404 &&
      error.response.data?.detail?.includes("No tasks found")
    ) {
      return [];
    }
    console.error("Error fetching tasks:", error);
    throw error;
  }
};
export interface TaskPayload {
  task_name: string;
  project_id: string;
  Assign_to: string;
  due_date: string;
  tags?: any[] | null;
  priority: string;
  status: string;
  view?: number | null;
  descriptions?: string | null;
  upload_file?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  estimated_hours?: number | null;
  created_by?:string ;
}

export const createTask = async (_token: string | null,taskData: FormData) => {
  try {
    const response = await axios.post(TASK_API_URL, taskData, {
      headers: {
        "Content-Type": "multipart/form-data",
        accept: "application/json",
         authorization: "Bearer " + _token,
      },
    });
    return response.data;
  } catch (error) {
    console.error(" Error creating task:", error);
    throw error;
  }
};

export const deleteTask = async (_token: string | null,taskId: string): Promise<void> => {
  try {
    await axios.delete(`${API_BASE_PATH}/Task/${taskId}`, {
      headers: {
        accept: "*/*",
         authorization: "Bearer " + _token,
      },
    });
  } catch (error) {
    console.error(`Error deleting task ${taskId}:`, error);
    throw error;
  }
};

export const getTaskById = async (_token: string | null,taskId: string): Promise<Tasking> => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/Task/${taskId}`, {
      headers: {
        accept: "application/json",
         authorization: "Bearer " + _token,

      },
    });

    const item = response.data;

    const transformed: Tasking = {
      taskId: item.task_id,
      taskName: item.task_name,
      assignTo: item.Assign_to,
      dueDate: item.due_date,
      tags: item.tags || [],
      priority: item.priority,
      status: item.status,
      view: item.view,
      description: item.descriptions,
      uploadFile: item.upload_file,
      startDate: item.start_date,
      endDate: item.end_date,
      totalHours: item.total_hours,
      estimatedHours: item.estimated_hours,
      taskStart: item.task_start,
      taskEnd: item.task_end,
      projectId: item.project_id,

      employee: {
        employeeId: item.employee?.employee_id || "",
        username: item.employee?.username || "",
        email: item.employee?.email || "",
      },
      project: {
        projectId: item.project?.project_id || "",
        projectName: item.project?.project_name || "",
        projectVersion: item.project?.project_version || "",
        status: item.project?.status || "",
      },
    };

    return transformed;
  } catch (error) {
    console.error("Error fetching task by ID:", error);
    throw error;
  }
};

export const updateTask = async (_token: string | null,taskId: string, formData: FormData) => {
  try {
    const response = await axios.put(
      `${API_BASE_PATH}/Task/${taskId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          accept: "application/json",
                authorization: "Bearer " + _token,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating task ${taskId}:`, error);
    throw error;
  }
};
